/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2023-09-27 18:32:44
 * @LastEditors: sueRimn
 * @LastEditTime: 2024-09-05 18:06:30
 */
import request from '@/utils/request'
interface ProjectListParamsType {}

interface importProjectParamsType {
  file_id?: string
  hash?: string
  file?: any
}

export interface ProjectDetailLogParams {
  project_id: number
  pm_id: number
}

// 中台指派
export async function projectAssign(params: any) {
  return request('/api/v2/project/assign', {
    method: 'POST',
    data: params
  })
}

// 项目列表
export async function apiProjectGetNormalList(params: ProjectListParamsType) {
  return request('/api/v2/project/search_leads_list', {
    method: 'POST',
    data: params
  })
}

// 项目卡片视图列表
export async function projectCardList(params: ProjectListParamsType) {
  return request('/api/v2/project/search_leads_card_list', {
    method: 'POST',
    data: params
  })
}

// 导入项目
export async function importProject(params: importProjectParamsType) {
  return request('/api/v1/project/import', {
    method: 'POST',
    data: params
  })
}

// 获取导入项目状态
export async function getImportStatus(params: importProjectParamsType) {
  return request('/api/v1/project/get_import_status', {
    method: 'POST',
    data: params
  })
}
